import { render, staticRenderFns } from "./ShippingCities.vue?vue&type=template&id=17ff03ce&"
import script from "./ShippingCities.vue?vue&type=script&lang=js&"
export * from "./ShippingCities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports